<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="22" :lg="20" :xl="18">
        <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
          <div class="form-section">
            <div class="form-section__title">Shaxsiy ma'lumotlar</div>

            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Viloyat" prop="region_id">
                  <el-select
                    v-model="form.region_id"
                    style="width: 100%"
                    size="large"
                    :loading="regionsLoading"
                    @change="onChangePersonalRegion"
                  >
                    <el-option
                      v-for="region in regions"
                      :key="region.id"
                      :value="region.id"
                      :label="region.title"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Tuman" prop="district_id">
                  <el-select
                    v-model="form.district_id"
                    style="width: 100%"
                    size="large"
                    :loading="personalDistrictsLoading"
                  >
                    <el-option
                      v-for="district in personalDistricts"
                      :key="district.id"
                      :value="district.id"
                      :label="district.title"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="F.I.O" prop="fullname">
                  <el-input size="large" v-model="form.fullname" />
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Pinfl" prop="pinfl">
                  <el-input
                    size="large"
                    v-model="form.pinfl"
                    maxlength="14"
                    inputmode="numeric"
                    @input="onPinflInput"
                  />
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Okrug" prop="okrug">
                  <el-input
                    v-model="form.okrug"
                    size="large"
                    placeholder="Okrugni kiriting"
                  />
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Fraksiya" prop="faction_id">
                  <el-select
                    v-model="selectedFactionValue"
                    style="width: 100%"
                    size="large"
                    clearable
                    filterable
                    placeholder="Fraksiyani tanlang"
                    :loading="factionsLoading"
                    :disabled="isCreatingFaction"
                    @change="onChangeFaction"
                  >
                    <el-option
                      v-for="faction in factions"
                      :key="faction.id"
                      :value="faction.id"
                      :label="faction.title"
                    />
                    <el-option
                      :value="newFactionOptionValue"
                      label="Yangi fraksiya yaratish"
                      class="create-new-option"
                    >
                      <el-icon><Plus /></el-icon>
                      <span>Yangi fraksiya yaratish</span>
                    </el-option>
                  </el-select>

                  <div v-if="isCreatingFaction" class="input-with-action">
                    <el-input
                      v-model="form.new_faction_title"
                      size="large"
                      placeholder="Yangi fraksiya nomini kiriting"
                      @input="onNewFactionInput"
                    />
                    <el-button link type="danger" @click="closeNewFactionInput">
                      <el-icon><Close /></el-icon>
                    </el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div class="form-section">
            <div class="form-section__title">Mahalla biriktirish</div>

            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Viloyat">
                  <el-select
                    v-model="quarterForm.region_id"
                    style="width: 100%"
                    size="large"
                    :loading="regionsLoading"
                    @change="onChangeQuarterRegion"
                  >
                    <el-option
                      v-for="region in regions"
                      :key="region.id"
                      :value="region.id"
                      :label="region.title"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Tuman">
                  <el-select
                    v-model="quarterForm.district_id"
                    style="width: 100%"
                    size="large"
                    :loading="quarterDistrictsLoading"
                    @change="onChangeQuarterDistrict"
                  >
                    <el-option
                      v-for="district in quarterDistricts"
                      :key="district.id"
                      :value="district.id"
                      :label="district.title"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item
                  label="Mahallalar"
                  prop="quarter_ids"
                  :error="quarterSelectionError"
                >
                  <el-select
                    v-model="quarterForm.quarter_ids"
                    multiple
                    filterable
                    style="width: 100%"
                    size="large"
                    placeholder="Mahallalarni tanlang"
                    :loading="quartersLoading"
                    @change="onQuarterSelectionChange"
                  >
                    <el-option
                      v-for="quarter in quarterOptions"
                      :key="quarter.id"
                      :value="quarter.id"
                      :label="quarter.title"
                      :disabled="isQuarterAlreadySelected(quarter.id)"
                    >
                      <div
                        v-if="isQuarterAlreadySelected(quarter.id)"
                        class="quarter-option"
                      >
                        <span class="quarter-option__label is-selected">
                          {{ quarter.title }}
                        </span>
                        <span class="quarter-option__action is-selected">
                          Tanlangan
                        </span>
                      </div>

                      <div v-else class="quarter-option">
                        <span class="quarter-option__label">
                          {{ quarter.title }}
                        </span>
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="section-actions">
              <el-button
                type="primary"
                plain
                :disabled="!canAddQuarterGroup"
                @click="addQuarterGroup"
              >
                Qo'shish
              </el-button>
            </div>

            <div v-if="selectedQuarterGroups.length" class="selected-groups">
              <div class="selected-groups__title">Tanlangan mahallalar:</div>

              <div
                v-for="group in selectedQuarterGroups"
                :key="getGroupKey(group.region_id, group.district_id)"
                class="selected-group"
              >
                <div class="selected-group__content">
                  <div class="selected-group__location">
                    {{ group.region_title }}, {{ group.district_title }}.
                  </div>
                  <div class="selected-group__label">Mahallalar:</div>
                  <div class="selected-group__text">
                    {{ formatQuarterTitles(group.quarters) }}
                  </div>
                </div>

                <button
                  type="button"
                  class="selected-group__remove"
                  @click="removeQuarterGroup(group)"
                ><el-icon><Close /></el-icon></button>
              </div>
            </div>
          </div>

          <el-form-item>
            <el-button class="custom-btn" @click="$router.go(-1)">Orqaga</el-button>
            <el-button class="custom-btn" type="primary" @click="onSubmit">
              Saqlash
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Close, Plus } from "@element-plus/icons-vue";
import { ElNotification } from "element-plus";

export default {
  name: "DeputyForm",
  components: {
    Close,
    Plus,
  },
  data() {
    const validatePinfl = (rule, value, callback) => {
      if (!value) {
        callback(new Error("Majburiy maydon"));
        return;
      }

      if (!/^\d{14}$/.test(value)) {
        callback(new Error("Pinfl 14 ta raqamdan iborat bo'lishi kerak"));
        return;
      }

      callback();
    };

    const validateQuarterIds = (rule, value, callback) => {
      // Quarter selection can be either already added to the grouped list
      // or still pending inside the temporary assignment form.
      if (!this.form.quarter_ids.length && !this.quarterForm.quarter_ids.length) {
        callback(new Error("Kamida bitta mahalla tanlang"));
        return;
      }

      callback();
    };

    const validateFaction = (rule, value, callback) => {
      // Faction is required, but it can come either from an existing
      // dropdown option or from the temporary "new faction" input.
      if (this.selectedFactionValue || this.normalizeText(this.form.new_faction_title)) {
        callback();
        return;
      }

      callback(new Error("Fraksiyani tanlang yoki yangisini kiriting"));
    };

    return {
      loading: false,
      regionsLoading: false,
      factionsLoading: false,
      personalDistrictsLoading: false,
      quarterDistrictsLoading: false,
      quartersLoading: false,
      regions: [],
      factions: [],
      personalDistricts: [],
      quarterDistricts: [],
      quarterOptions: [],
      quarterSelectionError: "",
      selectedFactionValue: null,
      isCreatingFaction: false,
      newFactionOptionValue: "__new_faction__",
      quarterForm: {
        region_id: null,
        district_id: null,
        quarter_ids: [],
      },
      form: {
        id: null,
        fullname: null,
        region_id: null,
        district_id: null,
        pinfl: null,
        okrug: "",
        faction_id: null,
        new_faction_title: "",
        quarter_ids: [],
      },
      selectedQuarterGroups: [],
      rules: {
        fullname: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
        region_id: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        district_id: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
        okrug: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
        pinfl: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
          { validator: validatePinfl, trigger: "blur" },
        ],
        faction_id: [{ validator: validateFaction, trigger: "change" }],
        quarter_ids: [{ validator: validateQuarterIds, trigger: "change" }],
      },
    };
  },
  computed: {
    canAddQuarterGroup() {
      return (
        !!this.quarterForm.region_id &&
        !!this.quarterForm.district_id &&
        !!this.quarterForm.quarter_ids.length
      );
    },
  },
  methods: {
    getGroupKey(regionId, districtId) {
      return `${regionId || "region"}-${districtId || "district"}`;
    },
    normalizeText(value) {
      return String(value || "").trim();
    },
    getRegionTitle(regionId) {
      return this.regions.find((item) => item.id === regionId)?.title || "Noma'lum viloyat";
    },
    getDistrictTitle(districtId, districtList = []) {
      return (
        districtList.find((item) => item.id === districtId)?.title || "Noma'lum tuman"
      );
    },
    mergeFactionOptions(items = []) {
      const map = new Map(this.factions.map((item) => [item.id, item]));

      items.forEach((item) => {
        if (item?.id == null) return;
        map.set(item.id, item);
      });

      this.factions = Array.from(map.values());
    },
    onChangeFaction(value) {
      if (value === this.newFactionOptionValue) {
        this.openNewFactionInput();
        return;
      }

      this.form.faction_id = value || null;
      this.form.new_faction_title = "";
      this.$refs.formRef?.validateField("faction_id", () => {});
    },
    openNewFactionInput() {
      this.isCreatingFaction = true;
      this.selectedFactionValue = null;
      this.form.faction_id = null;
      this.form.new_faction_title = "";
      this.$refs.formRef?.validateField("faction_id", () => {});
    },
    closeNewFactionInput() {
      this.isCreatingFaction = false;
      this.form.new_faction_title = "";
      this.$refs.formRef?.validateField("faction_id", () => {});
    },
    onNewFactionInput() {
      this.$refs.formRef?.validateField("faction_id", () => {});
    },
    syncSelectedQuarterIds() {
      // Backend still expects a flat quarter_ids array, even though the UI
      // works with grouped selections by region and district.
      this.form.quarter_ids = this.selectedQuarterGroups.flatMap((group) =>
        group.quarters.map((quarter) => quarter.id)
      );
    },
    isQuarterAlreadySelected(quarterId) {
      return this.form.quarter_ids.includes(quarterId);
    },
    mergeQuarterOptions(items) {
      const map = new Map();

      [...this.quarterOptions, ...items].forEach((item) => {
        map.set(item.id, item);
      });

      this.quarterOptions = Array.from(map.values());
    },
    resetQuarterState() {
      // These fields belong only to the temporary "attach quarter" flow.
      this.quarterOptions = [];
      this.quarterForm.quarter_ids = [];
      this.quarterSelectionError = "";
    },
    resetQuarterForm() {
      this.quarterForm.region_id = null;
      this.quarterForm.district_id = null;
      this.quarterDistricts = [];
      this.resetQuarterState();
    },
    onQuarterSelectionChange(values) {
      // Prevent selecting quarters that are already added into one
      // of the grouped selections below.
      const availableValues = values.filter((id) => {
        const quarter = this.quarterOptions.find((item) => item.id === id);
        return quarter && !this.isQuarterAlreadySelected(id);
      });

      if (availableValues.length !== values.length) {
        this.quarterForm.quarter_ids = availableValues;
      }

      this.quarterSelectionError = "";
    },
    onChangePersonalRegion() {
      this.form.district_id = null;
      this.personalDistricts = [];
      this.getPersonalDistricts();
    },
    onChangeQuarterRegion() {
      this.quarterForm.district_id = null;
      this.quarterDistricts = [];
      this.resetQuarterState();
      this.getQuarterDistricts();
    },
    onChangeQuarterDistrict() {
      this.resetQuarterState();
      this.getQuarterOptions();
    },
    getRegions() {
      this.regionsLoading = true;
      return this.$http
        .get("/api/v1/regions")
        .then(({ data }) => {
          this.regions = data.regions || [];
        })
        .catch(() => {})
        .finally(() => {
          this.regionsLoading = false;
        });
    },
    getFactions() {
      this.factionsLoading = true;

      return this.$http
        .get("/api/v1/deputy-factions")
        .then(({ data }) => {
          this.mergeFactionOptions(data.factions || []);
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Fraksiyalarni yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.factionsLoading = false;
        });
    },
    getDistrictsByRegion(regionId, targetKey) {
      // The form has two independent region/district pairs:
      // one for deputy personal data, another for quarter lookup.
      if (!regionId) {
        this[targetKey] = [];
        return Promise.resolve([]);
      }

      const loadingKey =
        targetKey === "personalDistricts"
          ? "personalDistrictsLoading"
          : "quarterDistrictsLoading";

      this[loadingKey] = true;

      return this.$http
        .get("/api/v1/districts", {
          params: {
            region_id: regionId,
          },
        })
        .then(({ data }) => {
          this[targetKey] = data.districts || [];
          return this[targetKey];
        })
        .catch(() => {
          this[targetKey] = [];
          return [];
        })
        .finally(() => {
          this[loadingKey] = false;
        });
    },
    getPersonalDistricts() {
      return this.getDistrictsByRegion(this.form.region_id, "personalDistricts");
    },
    getQuarterDistricts() {
      return this.getDistrictsByRegion(this.quarterForm.region_id, "quarterDistricts");
    },
    getQuarterOptions() {
      if (!this.quarterForm.district_id) {
        this.quarterOptions = [];
        return;
      }

      this.quartersLoading = true;
      this.quarterOptions = [];
      this.$http
        .get("/api/v1/quarters", {
          params: {
            district_id: this.quarterForm.district_id,
          },
        })
        .then(({ data }) => {
          this.mergeQuarterOptions(data.quarters || []);
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Mahallalarni yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.quartersLoading = false;
        });
    },
    formatQuarterTitles(quarters) {
      return quarters.map((item) => item.title).join(", ");
    },
    addQuarterGroup() {
      if (!this.canAddQuarterGroup) {
        this.quarterSelectionError = "Kamida bitta mahalla tanlang";
        return;
      }

      const selectedQuarters = this.quarterOptions.filter((item) =>
        this.quarterForm.quarter_ids.includes(item.id)
      );

      if (!selectedQuarters.length) {
        this.quarterSelectionError = "Kamida bitta mahalla tanlang";
        return;
      }

      const groupKey = this.getGroupKey(
        this.quarterForm.region_id,
        this.quarterForm.district_id
      );
      // If the same region/district pair is selected multiple times,
      // merge quarters into a single visual group instead of duplicating rows.
      const existingGroupIndex = this.selectedQuarterGroups.findIndex(
        (item) => this.getGroupKey(item.region_id, item.district_id) === groupKey
      );
      const nextGroup = {
        region_id: this.quarterForm.region_id,
        region_title: this.getRegionTitle(this.quarterForm.region_id),
        district_id: this.quarterForm.district_id,
        district_title: this.getDistrictTitle(
          this.quarterForm.district_id,
          this.quarterDistricts
        ),
        quarters: selectedQuarters.map((item) => ({
          id: item.id,
          title: item.title,
        })),
      };

      if (existingGroupIndex >= 0) {
        const currentGroup = this.selectedQuarterGroups[existingGroupIndex];
        const quarterMap = new Map(
          currentGroup.quarters.map((quarter) => [quarter.id, quarter])
        );

        nextGroup.quarters.forEach((quarter) => {
          quarterMap.set(quarter.id, quarter);
        });

        this.selectedQuarterGroups.splice(existingGroupIndex, 1, {
          ...currentGroup,
          quarters: Array.from(quarterMap.values()),
        });
      } else {
        this.selectedQuarterGroups.push(nextGroup);
      }

      this.syncSelectedQuarterIds();
      // Clear the temporary attach form after moving its data into the grouped list.
      this.resetQuarterForm();
      this.$refs.formRef?.validateField("quarter_ids", () => {});
    },
    removeQuarterGroup(group) {
      this.selectedQuarterGroups = this.selectedQuarterGroups.filter(
        (item) =>
          this.getGroupKey(item.region_id, item.district_id) !==
          this.getGroupKey(group.region_id, group.district_id)
      );
      this.syncSelectedQuarterIds();
      this.$refs.formRef?.validateField("quarter_ids", () => {});
    },
    onPinflInput(value) {
      this.form.pinfl = String(value || "")
        .replace(/\D/g, "")
        .slice(0, 14);
    },
    createQuarterGroupsFromAttachedQuarters(attachedQuarters = []) {
      // Edit API returns nested attached_quarters grouped by region -> district -> quarters.
      // Flatten that shape into the component's local grouped structure.
      return attachedQuarters.flatMap((regionItem) =>
        (regionItem.districts || []).map((district) => ({
          region_id: regionItem.region_id ?? null,
          region_title:
            regionItem.region_title ?? this.getRegionTitle(regionItem.region_id),
          district_id: district.district_id ?? null,
          district_title: district.district_title ?? "Noma'lum tuman",
          quarters: (district.quarters || []).map((quarter) => ({
            id: quarter.quarter_id,
            title: quarter.quarter_title,
          })),
        }))
      );
    },
    getDeputy(id) {
      this.loading = true;
      this.$http
        .get(`/api/v1/deputies/${id}`)
        .then(async ({ data }) => {
          const deputyInfo = data.deputy_info || null;

          this.form.id = data.id;
          this.form.fullname = data.fullname;
          this.form.region_id = data.region_id;
          this.form.district_id = data.district_id;
          this.form.pinfl = data.pinfl;
          this.form.okrug = deputyInfo?.okrug || "";
          this.form.faction_id = deputyInfo?.faction_id ?? null;
          this.form.new_faction_title = "";
          this.selectedFactionValue = deputyInfo?.faction_id ?? null;
          this.isCreatingFaction = false;

          if (deputyInfo?.faction_id != null) {
            this.mergeFactionOptions([
              {
                id: deputyInfo.faction_id,
                title: deputyInfo.faction_title || `Fraksiya #${deputyInfo.faction_id}`,
              },
            ]);
          }

          await this.getPersonalDistricts();

          this.selectedQuarterGroups = this.createQuarterGroupsFromAttachedQuarters(
            data.attached_quarters || []
          );
          this.syncSelectedQuarterIds();
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Deputat ma'lumotini yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmit() {
      // If the user selected quarters but forgot to press "Qo'shish",
      // persist that temporary selection before validating and submitting.
      if (this.canAddQuarterGroup) {
        this.addQuarterGroup();
      }

      this.syncSelectedQuarterIds();

      this.$refs.formRef.validate((valid) => {
        if (!valid) return;

        this.loading = true;
        const newFactionTitle = this.normalizeText(this.form.new_faction_title);

        const formData = {
          fullname: this.form.fullname,
          region_id: this.form.region_id,
          district_id: this.form.district_id,
          pinfl: String(this.form.pinfl),
          okrug: this.normalizeText(this.form.okrug),
          quarter_ids: this.form.quarter_ids,
        };

        if (newFactionTitle) {
          formData.new_faction_title = newFactionTitle;
        } else {
          formData.faction_id = this.selectedFactionValue ?? null;
        }

        const request = this.form.id
          ? this.$http.put(`/api/v1/deputies/${this.form.id}`, formData)
          : this.$http.post("/api/v1/deputies", formData);

        request
          .then(() => {
            ElNotification({
              title: "Tabriklaymiz",
              message: "Muvaffaqiyatli saqlandi",
              type: "success",
            });
            this.$router.go(-1);
          })
          .catch(({ response }) => {
            ElNotification({
              title: "Xatolik",
              message: response?.data?.message || "Iltimos, qayta urinib ko'ring.",
              type: "error",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
  mounted() {
    this.getRegions();
    this.getFactions();

    if (this.$route.params.id) {
      this.getDeputy(this.$route.params.id);
    }
  },
};
</script>

<style scoped>
.form-section {
  border: 1px solid #dcdfe6;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  background: #fff;
}

.form-section__title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
}

.quarter-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.quarter-option__label {
  min-width: 0;
  flex: 1;
}

.quarter-option__label.is-selected {
  color: #909399;
}

.quarter-option__action {
  color: #f56c6c;
  font-size: 12px;
  cursor: pointer;
  flex-shrink: 0;
  text-decoration: underline;
}

.quarter-option__action.is-selected {
  color: #909399;
  text-decoration: none;
  cursor: default;
}

.selected-groups {
  margin-top: 8px;
}

.selected-groups__title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
}

.selected-group {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  margin-bottom: 10px;
  background: #fafafa;
}

.selected-group__content {
  flex: 1;
}

.selected-group__location {
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 6px;
}

.selected-group__label {
  font-size: 15px;
  color: #606266;
  margin-bottom: 4px;
}

.selected-group__text {
  line-height: 1.5;
}

.selected-group__remove {
  border: 0;
  background: transparent;
  color: #f56c6c;
  cursor: pointer;
  font-size: 18px;
  line-height: 0;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.input-with-action {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.input-with-action .el-input {
  flex: 1;
}

.create-new-option {
  color: var(--el-color-primary);
  font-weight: 500;
  border-top: 1px solid var(--el-border-color-lighter);
  display: flex;
  align-items: center;
  gap: 6px;
}

.section-actions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}
</style>
